import React from 'react'
import { Link } from 'react-router-dom'
import MessageUI from '../widgets/output/MessageUI'
import './PublicFooter.css'

const PublicFooterUI = ({context, messageList}) =>
  <div className='t_pub_footer g_flex_h'>
    {
      context.session.appCode !== 'finapp' &&
      <FooterItemUI context={context} itemLink='/pub/pricing'
        messageList={messageList} messageKey='c_pricing'
      />
    }

    {/* <FooterItemUI context={context} itemLink='/pub/terms'
      messageList={messageList} messageKey='c_terms'
    />
    <FooterItemUI context={context} itemLink='/pub/privacy'
      messageList={messageList} messageKey='c_privacy'
    />
    */}

    <a href='https://vert-one.com/terms-conditions/'><span className='g_no_wrap'>Terms</span></a>

    <a href='https://vert-one.com/privacy-policy/'><span className='g_no_wrap'>Privacy</span></a>

    <FooterItemUI context={context} itemLink='/pub/about'
      messageList={messageList} messageKey='c_about'
    />
    
  </div>

const FooterItemUI = ({context, messageList, messageKey, itemLink}) =>
  <Link className='f_link' to={itemLink}>
    <MessageUI messageList={messageList} messageKey={messageKey} />
  </Link>

export default PublicFooterUI
